(function () {
  if (customElements.get('product-hero-carousel')) return;

  class ProductHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.viewport = this.querySelector('.csr-product-hero__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-csr-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-csr-dot]'));
      this.previousButton = this.querySelector('[data-csr-previous]');
      this.nextButton = this.querySelector('[data-csr-next]');
      this.status = this.querySelector('[data-csr-status]');
      this.currentIndex = 0;
      this.scrollFrame = null;

      if (!this.viewport || this.slides.length === 0) return;

      this.dataset.initialized = 'true';
      this.updateState(0);

      this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.show(index));
      });

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.currentIndex + 1);
        }
      });

      this.viewport.addEventListener('scroll', () => {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const width = this.viewport.clientWidth || 1;
          const index = Math.round(this.viewport.scrollLeft / width);
          this.updateState(index);
        });
      }, { passive: true });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-csr-slide]');
          if (!selectedSlide) return;
          this.show(Number(selectedSlide.dataset.slideIndex || 0));
        });
      }
    }

    show(index) {
      const count = this.slides.length;
      const nextIndex = (index + count) % count;
      const left = this.viewport.clientWidth * nextIndex;

      this.viewport.scrollTo({ left, behavior: this.reducedMotion() ? 'auto' : 'smooth' });
      this.updateState(nextIndex);
    }

    updateState(index) {
      const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      this.currentIndex = nextIndex;

      this.slides.forEach((slide, slideIndex) => {
        const isCurrent = slideIndex === nextIndex;
        slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');

        slide.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.tabIndex = isCurrent ? 0 : -1;
        });
      });

      this.dots.forEach((dot, dotIndex) => {
        const isCurrent = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isCurrent);
        dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      });

      if (this.status) {
        this.status.textContent = `Product ${nextIndex + 1} of ${this.slides.length}`;
      }
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  customElements.define('product-hero-carousel', ProductHeroCarousel);
})();
